module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADxQTFRFA2zq////QpHv4O38gbb1QpHw0OP7wNr6E3XrMojuUprxocj37/b+I37tcazzsNH4I3/tYqPykb/2////BouWHwAAABR0Uk5T/////////////////////////wBPT+cRAAAAm0lEQVR42ozTVxKFIAwF0ADS9TX3v1dHeSG0IdyvTI4VApzTAJWC0rOoU7PoU3BqqF+QUoa4k0NW9QXMa0cH1LcDijMNR6iCDkkNNHHq8T8fLYMsOEIfm/i+yufmJ1fhhocV3bNRmdkO2SBjz2u9ae2Ll6/w+OF28dNmP8Ysy8KizraE2dDBOBzlODDDxI0iN8jcMWAP0TiXAAMA2TUUy62KBWIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/icons/current-location.png
// module id = 699
// module chunks = 0